var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResidence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.71,153.22l32.18-21.67,32.18,21.54m-56.2-5.32v45.44H85.11V147.77m42.34-.23H115.26v-12.7h12.19Zm-24.37,0H90.89v-12.7h12.19Zm24.37-23.84H115.26V111h12.19Zm-24.37,0H90.89V111h12.19Zm48.1-1.91v6.41m0,17.31v6.41m0-53.86v6.41m18,17.32v6.41m-6.41,51.29v-16H150.54v17.95m18.6-35.91v6.41m0-53.86v6.41m0-30.77v6.41M151.38,73.7v6.41M133.22,73.7v6.41M78.27,142.35V95.93H140.6V181.8H86M121.09,62.16h59.6V181.8H138.28M107.52,90.67v4m0-21.31v5.77m0-24.37v5.78m0-23.09v5.77m-13,47.45v4m0-21.31v5.77m0-24.37v5.78m0-23.09v5.77m-13,47.45v4m0-21.31v5.77m0-24.37v5.78m0-23.09v5.77m-13.72,91V23.31h53V94.67"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidence);
export default __webpack_public_path__ + "static/media/RESIDENCE.b3537b90ddfceb7f1c4ab465d4fc03e3.svg";
export { ForwardRef as ReactComponent };